import CarriersFormUPS from './components/CarriersFormUPS';
import CarriersFormFedEx from './components/CarriersFormFedEx';

const Carriers = () => {
  return (
    <div className="carriers">
      <CarriersFormUPS />
      <CarriersFormFedEx />
    </div>
  );
};

export default Carriers;
